import { useDispatch } from 'react-redux';
import { EERIE } from 'HubStyleTokens/colors';
import UICloseButton from 'UIComponents/button/UICloseButton';
// @ts-expect-error Untyped module
import { closePatagoniaSidebar } from 'ContentEditorUI/redux/actions/panelActions';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PatagoniaSidebarHeader = ({
  headerText,
  subheaderText
}) => {
  const dispatch = useDispatch();
  function handleCloseSidebar() {
    UsageTracker.trackEditorInteraction({
      action: 'Toggle Sidebar',
      event: 'Close sidebar'
    });
    dispatch(closePatagoniaSidebar());
  }
  return /*#__PURE__*/_jsxs(View, {
    borderBlockEndColor: "border-core-pressed",
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    children: [/*#__PURE__*/_jsxs(View, {
      marginBlockStart: "500",
      marginBlockEnd: "400",
      marginInline: "300",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: headerText
      }), subheaderText && /*#__PURE__*/_jsx(Text, {
        typography: "detail-200",
        marginBlockStart: "200",
        color: "text-tertiary-default",
        children: subheaderText
      })]
    }), /*#__PURE__*/_jsx(UICloseButton, {
      color: EERIE,
      "data-selenium": "save-and-close-sidebar",
      onClick: handleCloseSidebar,
      size: "medium"
    })]
  });
};
export default PatagoniaSidebarHeader;